import {
  Box,
  Typography,
  Link as MuiLink,
} from "@mui/material";

import { MixCodesDetails } from "../../components/assignPromotionFlowComponent/MixCodesDetails";
import { FormikContextType, useFormikContext } from "formik";
import TooltipText from "../../components/inputComponents/TooltipText";
import { CopyPromoInitValues } from "../../components/modals/CopyPromotionModal.types";
const mixCodesRef_local = 'https://wiki.coke.com/confluence/pages/viewpage.action?pageId=6127906';

export const MixCodesDetailsSetupComponent = () => {
  const formik: FormikContextType<CopyPromoInitValues> = useFormikContext();
  return (
    <Box p={1} my={2}>
      <TooltipText
        text="MiX Codes Details"
        textVariant="h6"
        tooltip={
          <Typography variant="body2">
            <MuiLink
              className="tooltip-link"
              href={mixCodesRef_local}
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </MuiLink>
            about MiX Codes solution that is used to generate codes.
          </Typography>
        }
      />
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Enter MiX Codes details if pincodes and/or viral codes are required for
        participation in this promotion.
      </Typography>
      <MixCodesDetails formik={formik} mainBoxClass='copy-promo-mixcodes' isEdit={false} />
    </Box>
  );
};
